import React from 'react';
import './App.scss';
import ErrorBoundary from './components/errorboundry/errorBoundary';
import AppRoutes from './routes';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from '../store';
import { AppInsightsErrorBoundary, ReactPlugin } from '@microsoft/applicationinsights-react-js';
import '@fortawesome/fontawesome-free/css/all.min.css';

const reactPlugin = new ReactPlugin();

const App = () => (
    <>
        <AppInsightsErrorBoundary onError={() => <h1>something went wrong</h1>} appInsights={reactPlugin}>
            <ErrorBoundary>
                <Provider store={store}>
                    <PersistGate persistor={persistor}>
                        <AppRoutes />
                    </PersistGate>
                </Provider>
            </ErrorBoundary>
        </AppInsightsErrorBoundary>
    </>
);

export default App;
